export default "__VITE_ASSET__1PcK7_vO__"